import { render, staticRenderFns } from "./brheader.vue?vue&type=template&id=291c7070&scoped=true&"
import script from "./brheader.vue?vue&type=script&lang=js&"
export * from "./brheader.vue?vue&type=script&lang=js&"
import style0 from "./brheader.vue?vue&type=style&index=0&id=291c7070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291c7070",
  null
  
)

export default component.exports